// extracted by mini-css-extract-plugin
module.exports = {"viewDeposit":"Index-Jtails_viewDeposit_2vdjV","isStyleDingBeauty":"Index-Jtails_isStyleDingBeauty_2xvhB"};